import lazyLoading from './lazyLoading';

export default {
    path: '/app',
    meta: {
        icon: 'el-icon-setting',
        label: '权限管理',
        hidden: false
    },
    component: require('../views/Home'),
    children: [
        {
            name: 'userList',
            path: 'user-list',
            component: lazyLoading('user/UserRoleList'), // 加载模块
            meta: {
                label: '权限管理',
                hidden: false,
                api: [
                    // 权限验证
                    // Apis.qukan.config.list
                ]
            }
        }
    ]
};



// WEBPACK FOOTER //
// ./src/router/user.js